import { Document, Page, View, StyleSheet, Text, Image, Font } from "@react-pdf/renderer";
import imgGaruda from '../../../assets/images/pngwing.png';
import srcRobotoItalic from '../../../assets/custom/font/roboto/Roboto-Italic.ttf';
import { useCallback, useEffect, useMemo, useState } from "react";
import TransaksiService from "../../../services/transaksi/TransaksiService";
import UserService from "../../../services/user/UserService";
import MasterService from "../../../services/master/MasterService";
import { formatDateStringLocalDate } from "../../../utilities/Utils";
import DraftAppendix from "./DraftAppendix";
import Kemasan from "../../../utilities/Kemasan";

Font.register({ family: 'Roboto-Italic', src: srcRobotoItalic })

const styles = StyleSheet.create({
    page: {
        paddingTop: 20,
        paddingBottom: 48,
        paddingHorizontal: 48,
        boxSizing: "border-box"
    },
    headingImg: {
        width: 50,
        height: 50,
        marginVertical: 15,
        marginHorizontal: 235,
    },
    headingEn: {
        fontSize: 8,
        textAlign: "center",
        textDecoration: "underline"
    },
    headingIn: {
        fontFamily: "Roboto-Italic",
        fontSize: 8,
        textAlign: "center",
        marginBottom: 3
    },
    textRefNo: {
        fontSize: 7,
        textAlign: "right",
        marginRight: 75
    },
    textBox: {
        fontSize: 7,
    },
    table: {
        border: '1 solid black',
        display: 'table',
        width: 'auto',
    },
    tableInf1: {
        borderTop: '1 solid black',
        borderBottom: '1 solid black',
        display: 'table',
        width: '20%',
    },
    tableInf2: {
        border: '1 solid black',
        display: 'table',
        width: '20%',
    },
    tableInf3: {
        border: '1 solid black',
        display: 'table',
        width: '20%',
    },
    tableInf4: {
        border: '1 solid black',
        display: 'table',
        width: '20%',
    },
    tableInf5: {
        borderTop: '1 solid black',
        borderBottom: '1 solid black',
        display: 'table',
        width: '20%',
    },
    tableRow: {
        flexDirection: 'row',
    },
    tableRowSign: {
        flexDirection: 'row',
        marginTop: 30
    },
    tableRowSignName: {
        flexDirection: 'row',
        marginTop: 20
    },
    tableCol1: {
        width: '30%',
        padding: 5,
        textAlign: 'left',
    },
    tableCol2: {
        width: '5%',
        padding: 5,
        textAlign: 'left',
    },
    tableCol3: {
        width: '60%',
        padding: 5,
        textAlign: 'left',
    },
    tableColTX1: {
        width: '28%',
        padding: 3,
        textAlign: 'left',
    },
    tableColTX2: {
        width: '25%',
        padding: 3,
        textAlign: 'left',
    },
    tableColTX3: {
        width: '40%',
        padding: 3,
        textAlign: 'left',
    },
    tableBox: {
        width: 'auto',
        display: 'table'
    },
    textEn: {
        fontSize: 8,
        textAlign: "left",
        textDecoration: "underline"
    },
    textIn: {
        fontFamily: "Roboto-Italic",
        fontSize: 8,
        textAlign: "left",
    },
    textEnInf: {
        fontSize: 8,
        textAlign: "center",
    },
    textInInf: {
        fontFamily: "Roboto-Italic",
        fontSize: 8,
        textAlign: "center",
    },
    textEnCenter: {
        fontSize: 8,
        textAlign: "center",
        textDecoration: "underline"
    },
    textInCenter: {
        fontFamily: "Roboto-Italic",
        fontSize: 8,
        textAlign: "center",
    },
    tableColBox1: {
        width: '30%',
        padding: 3,
        textAlign: 'left',
    },
    tableColBox2: {
        width: '5%',
        padding: 3,
        textAlign: 'left',
    },
    tableColBox3: {
        width: '60%',
        padding: 3,
        textAlign: 'left',
    },
    tableColBoxInf1: {
        width: '85%',
        borderBottom: '1 solid black',
        textAlign: 'Center',
    },
    tableColBoxInf2: {
        width: '85%',
        padding: 5,
        textAlign: 'Center',
    },
    tableColBoxAtt: {
        width: '85%',
        textAlign: 'left',
    },
    tableColBoxSign1: {
        width: '10%',
        textAlign: 'left',
    },
    tableColBoxSign2: {
        width: '20%',
        textAlign: 'left',
    },
    tableColBoxSign3: {
        width: '30%',
        textAlign: 'left',
    },
    tableColBoxSign5: {
        width: '50%',
        textAlign: 'center',
    },
    tableboxSign: {
        width: 'auto',
        display: 'table',
        marginTop: 15
    }
})

const DraftE = ({ dataDisposisi, datappm, qrImage }) => {

    let transaksiService = useMemo(() => new TransaksiService(), [])
    let userService = useMemo(() => new UserService(), [])
    let masterService = useMemo(() => new MasterService(), [])

    const [dataHc, setDataHc] = useState(null)
    const [upt, setUpt] = useState(null)
    const [negaraTujuan, setNegaraTujuan] = useState(null)
    const [pelMuat, setPelMuat] = useState(null)
    const [pelBongkar, setPelBongkar] = useState(null)
    const [ppmDetil, setPpmDetil] = useState([])
    const [ppmKontainer, setPpmKontainer] = useState([])
    const [ppmMutu, setPpmMutu] = useState({})
    const [ppmMutuProd, setPpmMutuProd] = useState([])
    const [ppmKemasan, setPpmKemasan] = useState([])

    const fetchAllData = useCallback(async () => {
        if (!datappm?.nomorAju || !dataDisposisi?.noTugas) {
            console.warn("datappm atau dataDisposisi belum tersedia");
            return;
        }

        try {
            const jsonMutuPK = {
                nomorAju: datappm.nomorAju,
                noProses: dataDisposisi.noTugas
            };

            const jsonPelMuat = {
                jnsPelabuhan: "D",
                kodePelabuhan: datappm.pelabuhanMuat
            };

            const jsonPelBongkar = {
                jnsPelabuhan: "L",
                kodePelabuhan: datappm.pelabuhanBongkar
            };

            const results = await Promise.allSettled([
                transaksiService.getHcMutuById(jsonMutuPK),
                userService.getUptById(datappm.kdUpt),
                masterService.getNegaraById(datappm.negaraPartner),
                masterService.getPelabuhanById(JSON.stringify(jsonPelMuat)),
                masterService.getPelabuhanById(JSON.stringify(jsonPelBongkar)),
                transaksiService.listPpmDetilAll(datappm.nomorAju),
                transaksiService.listPpmKemasanAll(datappm.nomorAju),
                transaksiService.listPpmContainerAll(datappm.nomorAju),
                transaksiService.getPpmMutuById(datappm.nomorAju),
                transaksiService.listPpmMutuProdAll(datappm.nomorAju)
            ])

            const [
                resHc,
                resUpt,
                resNeg,
                resPelMuat,
                resPelBongkar,
                resDetil,
                resKemasanAll,
                resKontainer,
                resMutu,
                resMutuProd
            ] = results

            const getData = (res, fallback = []) =>
                res.status === "fulfilled"
                    ? res.value?.data?.data ?? res.value?.data ?? fallback
                    : fallback;

            // Update state (batched oleh React)
            setDataHc(getData(resHc));
            setUpt(getData(resUpt, {}));
            setNegaraTujuan(getData(resNeg, {}))
            setPelMuat(getData(resPelMuat, {}));
            setPelBongkar(getData(resPelBongkar, {}));
            setPpmDetil(getData(resDetil));
            setPpmKemasan(getData(resKemasanAll));
            setPpmKontainer(getData(resKontainer));
            setPpmMutu(getData(resMutu, {}));
            setPpmMutuProd(getData(resMutuProd));
        } catch (error) {

        }
    }, [datappm, transaksiService, masterService, userService, dataDisposisi])

    useEffect(() => {
        let isMounted = true;
        if (!datappm) return;

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [datappm, fetchAllData]);

    // useEffect(() => {
    //     if (!datappm) return
    //     const fetchAllData = async () => {
    //         try {
    //             let jsonMutuPK = {
    //                 nomorAju: datappm.nomorAju,
    //                 noProses: dataDisposisi.noTugas
    //             }
    //             const resHc = await transaksiService.getHcMutuById(jsonMutuPK)
    //             setDataHc(resHc.data)

    //             const resUpt = await userService.getUptById(datappm.kdUpt)
    //             // console.log(resUpt)
    //             setUpt(resUpt.data)

    //             const resNeg = await masterService.getNegaraById(datappm.negaraPartner)
    //             setNegaraTujuan(resNeg.data)

    //             const jsonPelMuat = {
    //                 jnsPelabuhan: "D",
    //                 kodePelabuhan: datappm.pelabuhanMuat
    //             }
    //             const resPelDn = await masterService.getPelabuhanById(JSON.stringify(jsonPelMuat))
    //             setPelMuat(resPelDn.data)

    //             const jsonPelLn = {
    //                 jnsPelabuhan: "L",
    //                 kodePelabuhan: datappm.pelabuhanBongkar
    //             }
    //             const resPelLn = await masterService.getPelabuhanById(JSON.stringify(jsonPelLn))
    //             setPelBongkar(resPelLn.data)

    //             const resDetil = await transaksiService.listPpmDetilAll(datappm.nomorAju)
    //             setPpmDetil(resDetil.data.data)

    //             const resMutu = await transaksiService.getPpmMutuById(datappm.nomorAju)
    //             setPpmMutu(resMutu.data)

    //             const resMutuProd = await transaksiService.listPpmMutuProdAll(datappm.nomorAju)
    //             setPpmMutuProd(resMutuProd.data.data)

    //             const resKemasanAll = await transaksiService.listPpmKemasanAll(datappm.nomorAju)
    //             setPpmKemasan(resKemasanAll.data.data)

    //             const resKontainer = await transaksiService.listPpmContainerAll(datappm.nomorAju)
    //             setPpmKontainer(resKontainer.data.data)

    //         } catch (error) {
    //             console.log(error)
    //         }
    //     }
    //     fetchAllData()
    // }, [datappm, transaksiService, masterService, userService, dataDisposisi])

    return (
        <Document>
            <Page size="LEGAL" style={styles.page} wrap={false}>
                <View>
                    <Image style={styles.headingImg} src={imgGaruda} />
                    <Text style={styles.headingEn}>THE REPUBLIC OF INDONESIA</Text>
                    <Text style={styles.headingIn}>REPUBLIK INDONESIA</Text>
                </View>
                <View>
                    <Text style={styles.headingEn}>MINISTRY OF MARINE AFFAIRS AND FISHERIES</Text>
                    <Text style={styles.headingIn}>KEMENTERIAN KELAUTAN DAN PERIKANAN</Text>
                </View>
                <View>
                    <Text style={styles.headingEn}>HEALTH CERTIFICATE</Text>
                    <Text style={styles.headingIn}>SERTIFIKAT KESEHATAN</Text>
                </View>
                <View>
                    <Text style={styles.headingEn}>FOR FISHERY PRODUCT INTENDED FOR EXPORT TO JAPAN</Text>
                    <Text style={styles.headingIn}>UNTUK HASIL PERIKANAN YANG DITUJUKAN UNTUK EKSPOR KE JEPANG</Text>
                </View>
                <View>
                    <Text style={styles.textRefNo}>Reference No: {dataHc !== null ? dataHc.noHcMutu : ''}</Text>
                </View>
                <View style={styles.table}>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol1}>
                            <Text style={styles.textBox}>COUNTRY OF DISPATCH</Text>
                        </View>
                        <View style={styles.tableCol2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={styles.tableCol3}>
                            <Text style={styles.textBox}>THE REPUBLIC OF INDONESIA</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol1}>
                            <Text style={styles.textBox}>COMPETENT AUTHORITY</Text>
                        </View>
                        <View style={styles.tableCol2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={styles.tableCol3}>
                            <Text style={styles.textBox}>MARINE AND FISHERIES QUALITY ASSURANCE AGENCY (MFQAA)</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol1}>
                            <Text style={styles.textBox}>INSPECTION AGENCY</Text>
                        </View>
                        <View style={styles.tableCol2}>
                            <Text style={styles.textBox}>:</Text>
                        </View>
                        <View style={styles.tableCol3}>
                            <Text style={styles.textBox}>{upt !== null ? upt.nmInggris : '-'}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.tableBox}>
                    <View style={styles.tableRow}>
                        <View style={styles.tableColTX1}>
                            <Text style={styles.textEn}>CONSIGNMENT INFORMATION</Text>
                        </View>
                        <View style={styles.tableColTX2}>
                            <Text style={styles.textIn}>/ INFORMASI PENGIRIMAN</Text>
                        </View>
                        <View style={styles.tableColTX3}>
                            <Text style={styles.textBox}></Text>
                        </View>
                    </View>
                    <View style={styles.table}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBox1}>
                                <Text style={styles.textEn}>Name and Address Consignor</Text>
                                <Text style={styles.textIn}>Nama dan Alamat Pengirim</Text>
                            </View>
                            <View style={styles.tableColBox2}>
                                <Text style={styles.textBox}>:</Text>
                            </View>
                            <View style={styles.tableCol3}>
                                <Text style={styles.textBox}>{dataHc !== null ? dataHc.nmPengirim : ''}</Text>
                                <Text style={styles.textBox}>{dataHc !== null ? dataHc.alPengirim : ''}</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBox1}>
                                <Text style={styles.textEn}>Name and Address Establishment</Text>
                                <Text style={styles.textIn}>Nama dan Alamat Unit Pengolahan Ikan</Text>
                            </View>
                            <View style={styles.tableColBox2}>
                                <Text style={styles.textBox}>:</Text>
                            </View>
                            <View style={styles.tableCol3}>
                                <Text style={styles.textBox}>{dataHc !== null ? dataHc.nmUpi : ''}</Text>
                                <Text style={styles.textBox}>{dataHc !== null ? dataHc.alUpi : ''}</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBox1}>
                                <Text style={styles.textEn}>Register Number</Text>
                                <Text style={styles.textIn}>Nomor Registrasi</Text>
                            </View>
                            <View style={styles.tableColBox2}>
                                <Text style={styles.textBox}>:</Text>
                            </View>
                            <View style={styles.tableCol3}>
                                <Text style={styles.textBox}>{dataHc !== null ? dataHc.noRegUpi : ''}</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBox1}>
                                <Text style={styles.textEn}>Product Description</Text>
                                <Text style={styles.textIn}>Deskripsi Produk</Text>
                            </View>
                            <View style={styles.tableColBox2}>
                                <Text style={styles.textBox}>:</Text>
                            </View>
                            <View style={styles.tableCol3}>
                                <Text style={styles.textBox}>{ppmMutu !== null ? ppmMutu.mutuDesk : ''}</Text>
                            </View>
                        </View>
                        <View style={styles.table}>
                            <View style={styles.tableRow}>
                                <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1 }]}>
                                    <Text style={styles.textEnInf}>Species (Scientific Name)/</Text>
                                    <Text style={styles.textInInf}>Spesies (Nama Latin)</Text>
                                </View>
                                <View style={[styles.tableCol, { width: "16%", borderRightWidth: 1 }]}>
                                    <Text style={styles.textEnInf}>Type of packages/</Text>
                                    <Text style={styles.textInInf}>Jenis Kemasan</Text>
                                </View>
                                <View style={[styles.tableCol, { width: "19%", borderRightWidth: 1 }]}>
                                    <Text style={styles.textEnInf}>Number of packages/</Text>
                                    <Text style={styles.textInInf}>Nomor Kemasan</Text>
                                </View>
                                <View style={[styles.tableCol, { width: "15%", borderRightWidth: 1 }]}>
                                    <Text style={styles.textEnInf}>Net weight (kg)</Text>
                                    <Text style={styles.textInInf}>Berat Bersih (kg)</Text>
                                </View>
                                <View style={[styles.tableCol, { width: "23%" }]}>
                                    <Text style={styles.textEnInf}>Date (period) of Production</Text>
                                    <Text style={styles.textInInf}>Tanggal (Periode) Produksi</Text>
                                </View>
                            </View>
                            {
                                ppmDetil.length <= 3 ?
                                    (
                                        ppmDetil.map((detil, index) => {
                                            return (
                                                <>
                                                    <View key={index} style={[styles.tableRow]}>
                                                        <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                            <Text style={[styles.textInInf]}>{detil.namaLatin}</Text>
                                                        </View>
                                                        {
                                                            index === 0 ?
                                                                (
                                                                    <>
                                                                        <View style={[styles.tableCol, { width: "16%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                                            {
                                                                                ppmKemasan.map((kms, idxKms) => {
                                                                                    return (
                                                                                        <>
                                                                                            <Text key={idxKms} style={[styles.textEnInf]}>{<Kemasan id={kms.kodeKemasan} />}</Text>
                                                                                        </>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </View>
                                                                        <View style={[styles.tableCol, { width: "19%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                                            {
                                                                                ppmKemasan.map((kms, idxKms) => {
                                                                                    return (
                                                                                        <>
                                                                                            <Text key={idxKms} style={[styles.textEnInf]}>{kms.jumlah}</Text>
                                                                                        </>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </View>
                                                                    </>
                                                                ) :
                                                                (
                                                                    <>
                                                                        <View style={[styles.tableCol, { width: "16%", borderRightWidth: 1, borderTopWidth: 0 }]}>
                                                                            <Text style={[styles.textEnInf]}></Text>
                                                                        </View>
                                                                        <View style={[styles.tableCol, { width: "19%", borderRightWidth: 1, borderTopWidth: 0 }]}>
                                                                            <Text style={[styles.textEnInf]}></Text>
                                                                        </View>
                                                                    </>
                                                                )
                                                        }
                                                        <View style={[styles.tableCol, { width: "15%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                            <Text style={[styles.textEnInf]}>{detil.jumlah}</Text>
                                                        </View>
                                                        {
                                                            index === 0 ?
                                                                (
                                                                    <View style={[styles.tableCol, { width: "27%", borderTopWidth: 1 }]}>
                                                                        {
                                                                            ppmMutuProd.length <= 3 ?
                                                                                (
                                                                                    ppmMutuProd.map((mutuProd, index) => {
                                                                                        return (
                                                                                            <Text key={index} style={[styles.textEnInf]}>
                                                                                                {mutuProd.mutuProdTgl}
                                                                                            </Text>
                                                                                        )
                                                                                    })
                                                                                ) :
                                                                                (
                                                                                    <Text key={index} style={[styles.textEnInf]}>
                                                                                        See Appendix
                                                                                    </Text>
                                                                                )
                                                                        }
                                                                        {/* {
                                                                            ppmMutuProd.map((mutuProd, index) => {
                                                                                return (
                                                                                    <Text key={index} style={[styles.textEnInf]}>
                                                                                        {mutuProd.mutuProdTgl}
                                                                                    </Text>
                                                                                )
                                                                            })
                                                                        } */}
                                                                    </View>
                                                                ) :
                                                                (
                                                                    <View style={[styles.tableCol, { width: "27%", borderTopWidth: 0 }]} />
                                                                )
                                                        }
                                                    </View>
                                                </>
                                            )
                                        })
                                    ) :
                                    (
                                        <>
                                            <View style={[styles.tableRow]}>
                                                <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                    <Text style={[styles.textInInf]}>See Appendix</Text>
                                                </View>
                                                <View style={[styles.tableCol, { width: "16%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                    <Text style={[styles.textEnInf]}></Text>
                                                </View>
                                                <View style={[styles.tableCol, { width: "19%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                    <Text style={[styles.textEnInf]}></Text>
                                                </View>
                                                <View style={[styles.tableCol, { width: "15%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                    <Text style={[styles.textEnInf]}>See Appendix</Text>
                                                </View>
                                                {
                                                    <View style={[styles.tableCol, { width: "27%", borderTopWidth: 1 }]}>
                                                        {
                                                            ppmMutuProd.length <= 3 ?
                                                                (
                                                                    ppmMutuProd.map((mutuProd, index) => {
                                                                        return (
                                                                            <Text key={index} style={[styles.textEnInf]}>
                                                                                {mutuProd.mutuProdTgl}
                                                                            </Text>
                                                                        )
                                                                    })
                                                                ) :
                                                                (
                                                                    <Text style={[styles.textEnInf]}>
                                                                        See Appendix
                                                                    </Text>
                                                                )
                                                        }
                                                        {/* {
                                                            ppmMutuProd.map((mutuProd, index) => {
                                                                return (
                                                                    <Text key={index} style={[styles.textEnInf]}>
                                                                        {mutuProd.mutuProdTgl}
                                                                    </Text>
                                                                )
                                                            })
                                                        } */}
                                                    </View>
                                                }
                                            </View>
                                        </>
                                    )
                            }
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBox1}>
                                <Text style={styles.textEn}>Place of Dispatch</Text>
                                <Text style={styles.textIn}>Tempat Pengiriman</Text>
                            </View>
                            <View style={styles.tableColBox2}>
                                <Text style={styles.textBox}>:</Text>
                            </View>
                            <View style={styles.tableCol3}>
                                <Text style={styles.textBox}>{pelMuat !== null ? pelMuat.uraianPelabuhan : ''}, INDONESIA</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBox1}>
                                <Text style={styles.textEn}>Place of Destination</Text>
                                <Text style={styles.textIn}>Tempat Penerimaan</Text>
                            </View>
                            <View style={styles.tableColBox2}>
                                <Text style={styles.textBox}>:</Text>
                            </View>
                            <View style={styles.tableCol3}>
                                <Text style={styles.textBox}>{pelBongkar !== null ? pelBongkar.uraianPelabuhan : ''}, {negaraTujuan !== null ? negaraTujuan.uraianNegara : ''}</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBox1}>
                                <Text style={styles.textEn}>Means of Transport</Text>
                                <Text style={styles.textIn}>Cara Transportasi</Text>
                            </View>
                            <View style={styles.tableColBox2}>
                                <Text style={styles.textBox}>:</Text>
                            </View>
                            <View style={styles.tableCol3}>
                                <Text style={styles.textBox}>{dataHc !== null ? dataHc.nmTrans : ''} / Voyage : {dataHc !== null ? dataHc.noFlight : ''}</Text>
                                <Text style={styles.textBox}>
                                    {
                                        ppmKontainer !== undefined && ppmKontainer !== null &&
                                        ppmKontainer.map((kont, index) => {
                                            return (
                                                <>
                                                    <Text style={styles.text}>
                                                        {kont.nomor} / {kont.nomorSegel} ;
                                                    </Text>
                                                </>
                                            )
                                        })
                                    }
                                </Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBox1}>
                                <Text style={styles.textEn}>Temperature Required During Storage and Transportation</Text>
                                <Text style={styles.textIn}>Suhu Selama penyimpanan dan transportasi</Text>
                            </View>
                            <View style={styles.tableColBox2}>
                                <Text style={styles.textBox}>:</Text>
                            </View>
                            <View style={styles.tableCol3}>
                                <Text style={styles.textBox}>{ppmMutu !== null ? ppmMutu.mutuTemp : ''}</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBox1}>
                                <Text style={styles.textEn}>Name and Address of Consigne</Text>
                                <Text style={styles.textIn}>Nama dan Alamat Penerima</Text>
                            </View>
                            <View style={styles.tableColBox2}>
                                <Text style={styles.textBox}>:</Text>
                            </View>
                            <View style={styles.tableCol3}>
                                <Text style={styles.textBox}>{dataHc !== null ? dataHc.nmPenerima : ''}</Text>
                                <Text style={styles.textBox}>{dataHc !== null ? dataHc.alPenerima : ''}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableBox}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableCol1}>
                                <Text style={styles.textEn}>ATTESTATION</Text>
                                <Text style={styles.textIn}>PERNYATAAN</Text>
                            </View>
                            <View style={styles.tableCol2}>
                                <Text style={styles.textBox}></Text>
                            </View>
                            <View style={styles.tableCol3}>
                                <Text style={styles.textBox}></Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBox2}>
                                <Text style={styles.textBox}>1.</Text>
                            </View>
                            <View style={styles.tableColBoxAtt}>
                                <Text style={styles.textEn}>The products described above originate from (an) approved establishment (s) and</Text>
                                <Text style={styles.textIn}>Produk yang diuraikan diatas berasal dari unit pengolahan ikan yang sudah diakui dan</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBox2}>
                                <Text style={styles.textBox}>2.</Text>
                            </View>
                            <View style={styles.tableColBoxAtt}>
                                <Text style={styles.textEn}>The products have been handled, prepared or processed, identified, stored and transported under a HACCP-Based Integrated Quality Management Programme, consistently implemented in accordance with the Food Sanitation Law - Ministry of Health, Labour and Welfare Japan and under the supervision of the Competent Authority.</Text>
                                <Text style={styles.textIn}>Produk telah ditangani, disiapkan, diolah, diidentifikasi, disimpan dan didistribusikan berdasarkan penerapan Program Manajemen Mutu Terpadu berdasarkan HACCP yang telah diterapkan secara konsisten sesuai dengan persyaratan Food Sanitation Law - Ministry of Health, Labour and Welfare Japan dan berada dalam pengawasan Otoritas Kompeten</Text>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={styles.tableboxSign}>
                    <View style={styles.tableRow}>
                        <View style={styles.tableColBoxSign3}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBoxSign2}>
                            <Text style={styles.textEn}>Done</Text>
                            <Text style={styles.textIn}>Dilaksanakan</Text>
                        </View>
                        <View style={styles.tableColBoxSign3}>
                            <Text style={styles.textBox}>{upt !== null ? upt.kota : ''}</Text>
                        </View>
                        <View style={styles.tableColBoxSign1}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBoxSign2}>
                            <Text style={styles.textEn}>On</Text>
                            <Text style={styles.textIn}>Pada</Text>
                        </View>
                        <View style={styles.tableColBoxSign3}>
                            <Text style={styles.textBox}>{dataHc !== null ? formatDateStringLocalDate(dataHc.tglHc) : ''}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableColBoxSign3}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBoxAtt}>
                            <Text style={styles.textBox}></Text>
                        </View>
                    </View>
                    <View style={styles.tableRowSign}>
                        <View style={styles.tableColBoxSign3}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBoxSign2}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBoxSign3}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBoxSign5}>
                            <Text style={styles.textEnCenter}>Signature of the official inspector</Text>
                            <Text style={styles.textInCenter}>Tanda tangan Inspektur Mutu</Text>
                        </View>
                        <View style={styles.tableColBoxSign2}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBoxSign3}>
                            <Text style={styles.textBox}></Text>
                        </View>
                    </View>
                    <View style={styles.tableRowSignName}>
                        <View style={styles.tableColBoxSign3}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBoxSign2}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBoxSign3}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBoxSign5}>
                            <Text style={[styles.textBox, { width: "100%" }]}>{dataHc !== null ? dataHc.nmPejabat : ''}</Text>
                            <Text style={styles.textEnCenter}>Name in capital letter</Text>
                            <Text style={styles.textInCenter}>Nama (dengan huruf besar)</Text>
                        </View>
                        <View style={styles.tableColBoxSign2}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBoxSign3}>
                            <Text style={styles.textBox}></Text>
                        </View>
                    </View>
                </View>
            </Page>
            {
                (ppmDetil.length > 3 || ppmMutuProd.length > 3) && 
                <>
                    <DraftAppendix ppmdetil={ppmDetil} datahc={dataHc} upt={upt} dataDisposisi={dataDisposisi} qrImage={qrImage} ppmMutuProd={ppmMutuProd} />
                </>
            }
        </Document>
    )
}

export default DraftE